<div class="control-group" *ngIf="!!fieldData">
    <div [innerHTML]="htmlTransform(fieldData.metadata.label)" [ngClass]="!!fieldData.metadata.controlOptions && !!fieldData.metadata.controlOptions.cssClass ? fieldData.metadata.controlOptions.cssClass : 'html-block-default'">
    </div>    
</div>
